// src/components/home/HomePageMainContainer.jsx
import React, { Suspense } from 'react';
// Images
import PlaneIcon from '../../assets/images/icons/plane-icon.png';
import MainImage from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-d3odcl.webp';
import NannyImage from '../../assets/images/main/mistress-maria-pro-domme-dominatrix-sissy-nammy-m-training.webp';
// Constants
import { CONTACT_PAGE_URL } from '../../utils/Routes';
// Eager (kept in initial bundle)
import GeneralTextBlock from '../general/GeneralTextBlock';
import { Link } from 'react-router-dom';
import CallToActionOne from '../cta/CallToActionOne';

// Lazy-split non-critical sections
const PageLinksComponent = React.lazy(() =>
  import('../general/PageLinksComponent')
);
const SocialBigPins = React.lazy(() => import('../socialMedia/SocialBigPins'));
const MainServices = React.lazy(() => import('../general/MainServices'));
const TestimonialSection = React.lazy(() =>
  import('../testimonials/TestimonialSection')
);

function HomePageMainContainer() {
  return (
    <main
      role='main'
      id='home-page-main'
      className='grid gap-y-24 w-full h-full pt-12 z-10 bg-colour1'
    >
      {/* Main intro (eager) */}
      <GeneralTextBlock
        title='About Mistress Maria'
        subtitle='Domination in Norfolk & Beyond'
        paraOne={`Welcome. I am Mistress Maria of Norfolk — a force of nature with a passion for power and a talent for exposing your deepest desires. Whether you serve as a slave, submissive, sissy, or obedient maid, know this: my time is precious, and your place is to honour it.`}
        paraTwo={`With a mind teeming with curiosity and creativity, I explore every facet of fetish, discipline, and domination. My smile may tempt you, but it's only a prelude to the scenarios I orchestrate — from strict old-school discipline to exquisite bondage, humiliation, pegging, and medical play.`}
        paraThree={`Trained in the fine art of sissy transformation and cross-dressing (with help from the fabulous Maid Jane), I tailor each session to both my mood and your obedience. Whether you’re a wimp desperate for guidance or a curious creature needing control, step into my world — where all your dreams and desires can come true.`}
        mainImageUrl={MainImage}
        imageAlt='Mistress Maria exuding power and sensuality'
        imageAria='Image of Mistress Maria, Norfolk’s refined dominatrix'
        ctaLink={CONTACT_PAGE_URL}
        ctaAria='Request a session with Mistress Maria'
        ctaText='Message / Booking'
      />

      <div className='bg-colour4'>
        {/* Social pins */}
        <section className='grid w-full'>
          <div className='grid w-full bg-colour2 py-12 lg:py-16'>
            <Suspense fallback={null}>
              <SocialBigPins />
            </Suspense>
          </div>
        </section>

        <div className='grid gap-y-16'>
          {/* Page info */}
          <Suspense fallback={null}>
            <PageLinksComponent />
          </Suspense>

          {/* Sessions info */}
          <Suspense fallback={null}>
            <MainServices />
          </Suspense>

          {/* Mrs Silk */}
          <section className='grid lg:min-h-[50vh] bg-colour4 py-8 lg:py-16'>
            <div className='grid gap-y-8 lg:gap-y-16 w-full px-6 lg:container lg:mx-auto'>
              <article className='grid lg:grid-cols-[2fr_1fr] gap-6 sm:gap-12 lg:gap-x-16'>
                {/* Text */}
                <section className='grid w-full items-center'>
                  <div className='grid gap-8 sm:gap-10 w-full h-fit'>
                    <div className='grid gap-2'>
                      <div>
                        <h2 className='text-4xl lg:text-5xl font-titleFont'>
                          Introducing Mrs Silk Maid Training
                        </h2>
                      </div>
                      <div>
                        <h3 className='text-xl lg:text-2xl uppercase text-colour6'>
                          The Elegance of Feminine Transformation
                        </h3>
                      </div>
                    </div>
                    <div className='text-md font-extralight tracking-wider grid gap-y-4 text-colour2'>
                      <div>
                        <p>
                          Mrs Silk is the softer, more seductive sister of
                          Mistress Maria — an exquisite persona designed to
                          tease, feminize, and transform. With elegance and
                          grace, Mrs Silk welcomes sissies, maids, and
                          submissives seeking beauty, poise, and polished
                          perfection.
                        </p>
                      </div>
                      <div>
                        <p>
                          From detailed makeup application to wig styling and
                          posture training, Mrs Silk guides your transformation
                          with patience and flair. Whether you crave delicate
                          guidance or a stern lesson in etiquette, she knows
                          exactly how to bring out the graceful girl hiding
                          inside.
                        </p>
                      </div>
                      <div>
                        <p>
                          Ready to meet your most feminine self? Then let Mrs
                          Silk unveil her wardrobe and transform your fantasy
                          into a reflection in the mirror.
                        </p>
                      </div>
                    </div>

                    {/* CTA */}
                    <section className='grid'>
                      <div className='grid w-fit mx-auto lg:mx-0'>
                        <Link
                          className='bg-colour6 grid hover:brightness-110 active:bg-colour6 w-full border-2 border-solid border-colour2 py-2 text-center text-colour1 font-serif px-12 uppercase'
                          to={CONTACT_PAGE_URL}
                          aria-label='Book a session with Mrs Silk'
                        >
                          Book Now
                        </Link>
                      </div>
                    </section>
                  </div>
                </section>

                {/* Image */}
                <section className='grid w-full items-center'>
                  <div className='relative'>
                    <img
                      src={NannyImage}
                      alt='Mrs Silk presenting feminine elegance and transformation'
                      aria-label='Image of Mrs Silk, embodying grace and sophistication'
                      className='mx-auto max-h-[60vh]'
                      width={1200}
                      height={800}
                      loading='lazy'
                      decoding='async'
                    />
                  </div>
                </section>
              </article>
            </div>
          </section>

          <CallToActionOne />

          {/* FMTY Section */}
          <section className='grid lg:min-h-[50vh] bg-colour4 py-8 lg:py-16'>
            <div className='grid gap-y-8 lg:gap-y-16 w-full px-6 lg:container lg:mx-auto'>
              <article className='grid lg:grid-cols-[2fr_1fr] gap-6 sm:gap-12 lg:gap-x-16'>
                {/* Text */}
                <section className='grid w-full items-center'>
                  <div className='grid gap-8 sm:gap-10 w-full h-fit'>
                    <div className='grid gap-2'>
                      <div>
                        <h2 className='text-4xl lg:text-5xl font-titleFont'>
                          Fly me to you (FMTY)
                        </h2>
                      </div>
                      <div>
                        <h3 className='text-xl lg:text-2xl uppercase text-colour6'>
                          Indulge in a Personal Encounter, Anywhere
                        </h3>
                      </div>
                    </div>

                    <div className='text-md font-extralight tracking-wider grid gap-y-4 text-colour2'>
                      <p>
                        Like what you see? If you desire a private encounter
                        with me in your city, let’s make it happen. My FMTY
                        experiences are tailored, luxurious, and absolutely
                        unforgettable.
                      </p>
                      <p>
                        All travel expenses — including airfare, hotel, meals,
                        and transport — are covered separately. The session
                        tribute is negotiated and based on location and
                        duration.
                      </p>
                      <p>
                        Advance notice is essential. A non-refundable deposit is
                        required at the time of booking to confirm your
                        exclusive time with me.
                      </p>
                      <p>
                        Submit an inquiry via my contact form, and let the
                        journey begin.
                      </p>
                    </div>

                    {/* CTA */}
                    <section className='grid'>
                      <div className='grid w-fit mx-auto lg:mx-0'>
                        <Link
                          className='bg-colour6 grid hover:brightness-110 active:bg-colour6 w-full border-2 border-solid border-colour2 py-2 text-center text-colour1 font-serif px-12 uppercase'
                          to={CONTACT_PAGE_URL}
                          aria-label='Book a Fly Me To You experience with Mistress Maria'
                        >
                          Contact Me
                        </Link>
                      </div>
                    </section>
                  </div>
                </section>

                {/* Image */}
                <section className='grid w-full items-center'>
                  <div className='relative'>
                    <img
                      src={PlaneIcon}
                      alt='Fly Me To You icon with plane'
                      aria-label='Plane icon representing FMTY travel sessions'
                      className='mx-auto w-48 lg:w-56'
                      width={224} // ~w-56 fallback; adjust if you know the intrinsic size
                      height={224}
                      loading='lazy'
                      decoding='async'
                    />
                    <div className='absolute top-0 left-0 w-full h-full' />
                  </div>
                </section>
              </article>
            </div>
          </section>

          {/* Reviews */}
          <Suspense fallback={null}>
            <TestimonialSection />
          </Suspense>
        </div>
      </div>

      {/* External ad (lazy) */}
      <section className='grid justify-center pb-4'>
        <a href='https://openadultdirectory.com/escorts/'>
          <img
            src='https://oad-img.com/omag/escorts-lg.jpg'
            alt='Open Adult Directory Escorts'
            loading='lazy'
            decoding='async'
            width='728'
            height='90'
          />
        </a>
      </section>
    </main>
  );
}

export default HomePageMainContainer;
